/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateTenantComponent } from './create-tenant/create-tenant.component';
import { ManageTenantComponent } from './manage-tenant/manage-tenant.component';
import { CanAuthenticationGuard } from '../providers/auth-guard';

/**
  * @ngdoc overview
  * @name TenantsModule.module:TenantsRoutingModule
  *
  * @description
  * description: To route to different components in tenants module based on the path given
*/
const routes: Routes = [
  {
    path: 'tenants/create-tenants',
    component: CreateTenantComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'TEN_C', data: {} }
  },
  {
    path: 'tenants/manage-tenants',
    component: ManageTenantComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'TEN_R', data: {} }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantsRoutingModule { }
